import { PdMailItem } from "./PdMailItem.js";
//#region src/pd-mail/pd-mail-item.ts
var tag = "pd-mail-item";
if (!customElements.get(tag)) customElements.define(tag, PdMailItem);
//#endregion
export { PdMailItem };
